var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.84,
    height: 25.635,
    viewBox: "0 0 28.84 25.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "boxes-stacked-solid",
    d: "M12.417,0h-2a2.4,2.4,0,0,0-2.4,2.4V8.011a3.207,3.207,0,0,0,3.2,3.2h6.409a3.207,3.207,0,0,0,3.2-3.2V2.4a2.4,2.4,0,0,0-2.4-2.4h-2V4.005a.8.8,0,0,1-.8.8h-2.4a.8.8,0,0,1-.8-.8ZM3.2,12.818a3.207,3.207,0,0,0-3.2,3.2v6.409a3.207,3.207,0,0,0,3.2,3.2h8.011a3.207,3.207,0,0,0,3.2-3.2V16.022a3.207,3.207,0,0,0-3.2-3.2h-2v4.005a.8.8,0,0,1-.8.8h-2.4a.8.8,0,0,1-.8-.8V12.818Zm14.42,12.818h8.011a3.207,3.207,0,0,0,3.2-3.2V16.022a3.207,3.207,0,0,0-3.2-3.2h-2v4.005a.8.8,0,0,1-.8.8h-2.4a.8.8,0,0,1-.8-.8V12.818h-2a3.172,3.172,0,0,0-1.988.691,4.011,4.011,0,0,1,.386,1.712v8.011a4.011,4.011,0,0,1-.386,1.712A3.172,3.172,0,0,0,17.624,25.635Z",
    fill: "#53a245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.3ac6910c01d9b9be13307da04b1804a3.svg";
export { ForwardRef as ReactComponent };